<template>
	<div class="overflow-hidden text-sm">
		<a
				:href="recommendation.url"
				:title="recommendation.name"
				class="mb-4 aspect-square flex items-center justify-center bg-white border border-defaultborder"
		>
			<img
					v-if="recommendation.image_url"
					:alt="recommendation.name"
					:src="recommendation.image_url"
					class="w-[90%] h-[90%] object-contain"
					loading="lazy"
			/>
		</a>
		<h3>
			<a
					:href="recommendation.url"
					:title="recommendation.name"
					class="text-sm"
			>
				{{ recommendation.name }}
			</a>
		</h3>
		<span v-if="recommendation.price !== null" class="price">
			{{ formattedPrice }}
		</span>
	</div>
</template>

<script lang="ts" setup>
import {computed} from "vue"
import {RecommendationInterface} from "@/js/interfaces/recommendation"

const props = defineProps<{
	recommendation: RecommendationInterface
}>()

const formattedPrice = computed(() => {
	if (props.recommendation.price === null) return ""
	return new Intl.NumberFormat("de-CH", {
		style: "currency",
		currency: "CHF"
	}).format(props.recommendation.price)
})
</script>
